var React = require('react');

function Houzz (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"}));
}

Houzz.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Houzz;

Houzz.default = Houzz;
